import { render } from "./restartTask.vue?vue&type=template&id=1c5f4e9a"
import script from "./restartTask.vue?vue&type=script&lang=js"
export * from "./restartTask.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__